import { Users_User_$reflection, Scope } from "../ServerTypes.fs.js";
import { sortBy, isEmpty, choose as choose_1, tryHead, contains, length, filter, append as append_1, empty as empty_1, singleton as singleton_1, map as map_1, cons, ofSeq as ofSeq_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createElement } from "react";
import React from "react";
import { FSharpSet__Add, FSharpSet__Contains, FSharpSet__Remove, ofSeq } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { comparePrimitives, safeHash, equals, createObj, compare } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { some, map as map_2, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Impl_createRemoveOptions, Impl_adjustPassive, Impl_defaultPassive } from "../fable_modules/Feliz.Listeners.1.1.0/./Listener.fs.js";
import { useEffect } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { map, empty, singleton, append, delay as delay_1, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { isNullOrWhiteSpace, join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Thoth_Fetch_FetchError__FetchError_get_Message, EPM_Domain_Events_Action_Fulfillment__Fulfillment_ToUrlString, EPM_Domain_Events_Action_Fulfillment__Fulfillment_tryParse_Static_Z721C83C5, EPM_Domain_Events_Maturity__Maturity_ToUrlString, EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5, EPM_Domain_Events_Action_Category__Category_ToUrlString, EPM_Domain_Events_Action_Category__Category_ToProperString, EPM_Domain_Events_Action_Category__Category_tryParse_Static_Z721C83C5, EPM_Domain_Events_Criticality__Criticality_ToUrlString, EPM_Domain_Events_Criticality__Criticality_tryParse_Static_Z721C83C5, EPM_Domain_Events_Condition__Condition_ToUrlString, EPM_Domain_Events_Condition__Condition_tryParse_Static_Z721C83C5, EPM_Domain_Events_Status__Status_ToUrlString, EPM_Domain_Events_Status__Status_tryParse_Static_Z721C83C5, Types_Scope__Scope_ToProperString } from "../Prelude.fs.js";
import { DomainEntities_tryParse_Z721C83C5, DomainEntities, Action_Fulfillment, Maturity, Action_Category, Criticality, Condition, Status } from "../DomainEvents.fs.js";
import { Union, Record, toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { EntityType_tryParse_Z721C83C5 } from "../ClientTypes.fs.js";
import { union_type, record_type, bool_type, class_type, string_type, list_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Cmd_OfPromise_perform, Cmd_none, Cmd_batch } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { many, single } from "../Api/Users.fs.js";
import { choose } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { useFeliz_React__React_useDebouncer_Static } from "../hooks/UseDebouncer.fs.js";
import "./EntitySelector.scss";

const PermissionSelector_allScope = ofArray([new Scope(1, []), new Scope(4, []), new Scope(2, []), new Scope(3, []), new Scope(6, []), new Scope(0, []), new Scope(5, [])]);

export function PermissionSelector_ScopeSelector(permissionSelector_ScopeSelectorInputProps) {
    const onChange = permissionSelector_ScopeSelectorInputProps.onChange;
    const initialValues = permissionSelector_ScopeSelectorInputProps.initialValues;
    let patternInput;
    const initial = ofSeq(initialValues, {
        Compare: compare,
    });
    patternInput = reactApi.useState(initial);
    const values = patternInput[0];
    const setValues = patternInput[1];
    const dependencies = [values];
    reactApi.useEffect(() => {
        onChange(ofSeq_1(values));
    }, dependencies);
    const patternInput_1 = reactApi.useState(false);
    const setShowMenu = patternInput_1[1];
    const ref = reactApi.useRef(undefined);
    const elemRef = ref;
    const callback = reactApi.useCallback((_arg) => {
        setShowMenu(false);
    }, []);
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_2 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_2);
    let removeOptions;
    const dependencies_1_3 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_3);
    let fn;
    const dependencies_1_4 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_4);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_5 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_5);
    let removeOptions_1;
    const dependencies_1_6 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_6);
    let fn_1;
    const dependencies_1_7 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append(singleton(["className", join(" ", ["is-full-width", "entity-selector"])]), delay_1(() => append(singleton(["ref", ref]), delay_1(() => append(patternInput_1[0] ? singleton(["className", "is-active"]) : empty(), delay_1(() => {
        let elems_3, elems_1, elms;
        return singleton((elems_3 = [createElement("div", createObj(ofArray([["className", "tags-input"], (elems_1 = toList(delay_1(() => append(map((s) => {
            let elems;
            return createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], (elems = [Types_Scope__Scope_ToProperString(s), createElement("button", createObj(Helpers_combineClasses("delete", ofArray([["className", "is-small"], ["onClick", (_arg_1) => {
                setValues(FSharpSet__Remove(values, s));
            }]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }, values), delay_1(() => singleton(createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["placeholder", "Choose Permissions"], ["readOnly", true], ["onClick", (_arg_2) => {
            setShowMenu(true);
        }]])))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton_1(["children", (elms = map_1((scope) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append(singleton(["children", Types_Scope__Scope_ToProperString(scope)]), delay_1(() => (FSharpSet__Contains(values, scope) ? append(singleton(["className", "is-active"]), delay_1(() => singleton(["onClick", (e) => {
            e.preventDefault();
            setValues(FSharpSet__Remove(values, scope));
        }]))) : singleton(["onClick", (e_1) => {
            e_1.preventDefault();
            setValues(FSharpSet__Add(values, scope));
        }]))))))))), PermissionSelector_allScope), createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
    })))))))))));
}

const StatusSelector_allStatus = ofArray([new Status(5, []), new Status(0, []), new Status(3, []), new Status(2, []), new Status(1, []), new Status(4, [])]);

export function StatusSelector_StatusSelector(statusSelector_StatusSelectorInputProps) {
    let elems, elems_1;
    const onChange = statusSelector_StatusSelectorInputProps.onChange;
    const required = statusSelector_StatusSelectorInputProps.required;
    const value = statusSelector_StatusSelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EPM_Domain_Events_Status__Status_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: toString(s),
        value: EPM_Domain_Events_Status__Status_ToUrlString(s),
    }), StatusSelector_allStatus))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const ConditionSelector_allCondition = ofArray([new Condition(0, []), new Condition(1, []), new Condition(2, []), new Condition(3, []), new Condition(4, [])]);

export function ConditionSelector_ConditionSelector(conditionSelector_ConditionSelectorInputProps) {
    let elems, elems_1;
    const onChange = conditionSelector_ConditionSelectorInputProps.onChange;
    const required = conditionSelector_ConditionSelectorInputProps.required;
    const value = conditionSelector_ConditionSelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EPM_Domain_Events_Condition__Condition_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: toString(s),
        value: EPM_Domain_Events_Condition__Condition_ToUrlString(s),
    }), ConditionSelector_allCondition))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const CriticalitySelector_allCriticality = ofArray([new Criticality(4, []), new Criticality(0, []), new Criticality(2, []), new Criticality(1, []), new Criticality(3, [])]);

export function CriticalitySelector_CriticalitySelector(criticalitySelector_CriticalitySelectorInputProps) {
    let elems, elems_1;
    const onChange = criticalitySelector_CriticalitySelectorInputProps.onChange;
    const required = criticalitySelector_CriticalitySelectorInputProps.required;
    const value = criticalitySelector_CriticalitySelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EPM_Domain_Events_Criticality__Criticality_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: toString(s),
        value: EPM_Domain_Events_Criticality__Criticality_ToUrlString(s),
    }), CriticalitySelector_allCriticality))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const CategorySelector_allCategory = ofArray([new Action_Category(0, []), new Action_Category(1, []), new Action_Category(3, []), new Action_Category(4, []), new Action_Category(2, []), new Action_Category(5, [])]);

export function CategorySelector_CategorySelector(categorySelector_CategorySelectorInputProps) {
    let elems, elems_1;
    const onChange = categorySelector_CategorySelectorInputProps.onChange;
    const required = categorySelector_CategorySelectorInputProps.required;
    const value = categorySelector_CategorySelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["className", "is-fullwidth"], ["onChange", (ev) => {
        onChange(EPM_Domain_Events_Action_Category__Category_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- All Scopes of Work --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: EPM_Domain_Events_Action_Category__Category_ToProperString(s),
        value: EPM_Domain_Events_Action_Category__Category_ToUrlString(s),
    }), CategorySelector_allCategory))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export const MaturitySelector_allMaturity = ofArray([new Maturity(5, []), new Maturity(3, []), new Maturity(4, []), new Maturity(6, []), new Maturity(2, []), new Maturity(1, [])]);

export function MaturitySelector_MaturitySelector(maturitySelector_MaturitySelectorInputProps) {
    let elems, elems_1;
    const onChange = maturitySelector_MaturitySelectorInputProps.onChange;
    const required = maturitySelector_MaturitySelectorInputProps.required;
    const value = maturitySelector_MaturitySelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EPM_Domain_Events_Maturity__Maturity_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: toString(s),
        value: EPM_Domain_Events_Maturity__Maturity_ToUrlString(s),
    }), MaturitySelector_allMaturity))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const FulfillmentSelector_allFulfillment = ofArray([new Action_Fulfillment(2, []), new Action_Fulfillment(1, []), new Action_Fulfillment(4, []), new Action_Fulfillment(3, []), new Action_Fulfillment(0, []), new Action_Fulfillment(5, [])]);

export function FulfillmentSelector_FulfillmentSelector(fulfillmentSelector_FulfillmentSelectorInputProps) {
    let elems, elems_1;
    const onChange = fulfillmentSelector_FulfillmentSelectorInputProps.onChange;
    const required = fulfillmentSelector_FulfillmentSelectorInputProps.required;
    const value = fulfillmentSelector_FulfillmentSelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EPM_Domain_Events_Action_Fulfillment__Fulfillment_tryParse_Static_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: toString(s),
        value: EPM_Domain_Events_Action_Fulfillment__Fulfillment_ToUrlString(s),
    }), FulfillmentSelector_allFulfillment))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const DomainEntityTypeSelector_allDomainEntities = ofArray([new DomainEntities(11, []), new DomainEntities(12, []), new DomainEntities(5, []), new DomainEntities(7, []), new DomainEntities(4, []), new DomainEntities(9, []), new DomainEntities(10, []), new DomainEntities(3, []), new DomainEntities(8, []), new DomainEntities(6, []), new DomainEntities(13, []), new DomainEntities(14, []), new DomainEntities(2, []), new DomainEntities(1, []), new DomainEntities(0, [])]);

export function DomainEntityTypeSelector_DomainEntitySelector(domainEntityTypeSelector_DomainEntitySelectorInputProps) {
    let elems, elems_1;
    const onChange = domainEntityTypeSelector_DomainEntitySelectorInputProps.onChange;
    const required = domainEntityTypeSelector_DomainEntitySelectorInputProps.required;
    const value = domainEntityTypeSelector_DomainEntitySelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(DomainEntities_tryParse_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2(toString, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s_1) => createElement("option", {
        children: toString(s_1),
        value: toString(s_1),
    }), DomainEntityTypeSelector_allDomainEntities))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

const EntityTypeSelector_allEntities = ofArray(["activity", "area", "certification", "document", "documentTracking", "facility", "location", "module", "preservation", "productionUnit", "punchList", "subsystem", "system", "tag", "technicalQuery"]);

export function EntityTypeSelector_EntitySelector(entityTypeSelector_EntitySelectorInputProps) {
    let elems, elems_1;
    const onChange = entityTypeSelector_EntitySelectorInputProps.onChange;
    const required = entityTypeSelector_EntitySelectorInputProps.required;
    const value = entityTypeSelector_EntitySelectorInputProps.value;
    const patternInput = Helpers_extractClasses(ofArray([["onChange", (ev) => {
        onChange(EntityType_tryParse_Z721C83C5(ev.target.value));
    }], ["defaultValue", defaultArg(map_2((v_1) => v_1, value), "")], (elems = toList(delay_1(() => append(!required ? singleton(createElement("option", {
        children: "-- Not Selected --",
        value: "",
    })) : empty(), delay_1(() => map_1((s) => createElement("option", {
        children: s,
        value: s,
    }), EntityTypeSelector_allEntities))))), ["children", reactApi.Children.toArray(Array.from(elems))])]));
    return createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}


class UserSelector_State extends Record {
    constructor(Data, Selected, Query, ProjectId, IsFetching) {
        super();
        this.Data = Data;
        this.Selected = Selected;
        this.Query = Query;
        this.ProjectId = ProjectId;
        this.IsFetching = IsFetching;
    }
}

function UserSelector_State_$reflection() {
    return record_type("EPM.App.Components.UserSelector.State", [], UserSelector_State, () => [["Data", list_type(Users_User_$reflection())], ["Selected", list_type(Users_User_$reflection())], ["Query", string_type], ["ProjectId", class_type("System.Guid")], ["IsFetching", bool_type]]);
}

class UserSelector_SelectMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectUserIds", "SelectUser", "ChangeUser", "SelectUsers", "RemoveUser", "QueryChange", "Fetch", "Fetched", "NotifyExternal"];
    }
}

function UserSelector_SelectMsg_$reflection() {
    return union_type("EPM.App.Components.UserSelector.SelectMsg", [], UserSelector_SelectMsg, () => [[["Item", list_type(class_type("System.Guid"))]], [["Item", Users_User_$reflection()]], [["Item", Users_User_$reflection()]], [["Item", list_type(Users_User_$reflection())]], [["Item", Users_User_$reflection()]], [["Item", string_type]], [], [["Item", list_type(Users_User_$reflection())]], []]);
}

function UserSelector_init(projectId, initialUsers) {
    return [new UserSelector_State(empty_1(), empty_1(), "", projectId, false), Cmd_batch(ofArray([singleton_1((dispatch) => {
        dispatch(new UserSelector_SelectMsg(0, [initialUsers]));
    }), singleton_1((dispatch_1) => {
        dispatch_1(new UserSelector_SelectMsg(6, []));
    })]))];
}

function UserSelector_fetchSelected(projectId, userIds) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr;
        return ((pr = map_1((userId) => single(projectId, userId), userIds), Promise.all(pr))).then((_arg) => (Promise.resolve(ofArray(choose((result) => {
            if (result.tag === 1) {
                console.error(some(result.fields[0]));
                return undefined;
            }
            else {
                return result.fields[0];
            }
        }, _arg)))));
    }));
}

function UserSelector_fetchUsers(projectId) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (many(projectId, empty_1()).then((_arg) => {
        const usersFetched = _arg;
        if (usersFetched.tag === 1) {
            const error = usersFetched.fields[0];
            console.warn(some(Thoth_Fetch_FetchError__FetchError_get_Message(error)), error);
            return Promise.resolve(empty_1());
        }
        else {
            return Promise.resolve(usersFetched.fields[0]);
        }
    }))));
}

function UserSelector_update(onSelectedEntitiesChange, msg, state) {
    switch (msg.tag) {
        case 1:
            return [new UserSelector_State(state.Data, cons(msg.fields[0], state.Selected), state.Query, state.ProjectId, state.IsFetching), singleton_1((dispatch) => {
                dispatch(new UserSelector_SelectMsg(8, []));
            })];
        case 2:
            return [new UserSelector_State(state.Data, singleton_1(msg.fields[0]), state.Query, state.ProjectId, state.IsFetching), singleton_1((dispatch_1) => {
                dispatch_1(new UserSelector_SelectMsg(8, []));
            })];
        case 3:
            return [new UserSelector_State(state.Data, append_1(state.Selected, msg.fields[0]), state.Query, state.ProjectId, state.IsFetching), singleton_1((dispatch_2) => {
                dispatch_2(new UserSelector_SelectMsg(8, []));
            })];
        case 5:
            return [new UserSelector_State(state.Data, state.Selected, msg.fields[0], state.ProjectId, state.IsFetching), Cmd_none()];
        case 7:
            return [new UserSelector_State(msg.fields[0], state.Selected, state.Query, state.ProjectId, false), Cmd_none()];
        case 6:
            return [new UserSelector_State(state.Data, state.Selected, state.Query, state.ProjectId, true), Cmd_OfPromise_perform(UserSelector_fetchUsers, state.ProjectId, (entities_1) => (new UserSelector_SelectMsg(7, [entities_1])))];
        case 8: {
            onSelectedEntitiesChange(state.Selected);
            return [state, Cmd_none()];
        }
        case 4:
            return [new UserSelector_State(state.Data, filter((s) => !equals(s, msg.fields[0]), state.Selected), state.Query, state.ProjectId, state.IsFetching), singleton_1((dispatch_3) => {
                dispatch_3(new UserSelector_SelectMsg(8, []));
            })];
        default:
            return [state, Cmd_OfPromise_perform((userIds) => UserSelector_fetchSelected(state.ProjectId, userIds), msg.fields[0], (entities) => (new UserSelector_SelectMsg(3, [entities])))];
    }
}

export function UserSelector_UsersSelector(userSelector_UsersSelectorInputProps) {
    const onSelectedUsersChange = userSelector_UsersSelectorInputProps.onSelectedUsersChange;
    const initialUsers = userSelector_UsersSelectorInputProps.initialUsers;
    const projectId = userSelector_UsersSelectorInputProps.projectId;
    let patternInput;
    const init = UserSelector_init(projectId, initialUsers);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, (msg, state) => UserSelector_update(onSelectedUsersChange, msg, state), (_arg, _arg_1) => {
    }), undefined, [initialUsers, onSelectedUsersChange]);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useFeliz_React__React_useDebouncer_Static("", (arg) => {
        dispatch(new UserSelector_SelectMsg(5, [arg]));
    }, 300);
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append((length(state_1.Data) > 0) ? singleton(["className", "is-active"]) : empty(), delay_1(() => {
        let elems_1, elms;
        return singleton((elems_1 = [createElement("div", createObj(Helpers_combineClasses("control", toList(delay_1(() => append(singleton(["children", createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["value", patternInput_1[0]]])))))]), delay_1(() => (state_1.IsFetching ? singleton(["className", "is-loading"]) : empty())))))))), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton_1(["children", (elms = map_1((entity) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append(singleton(["children", entity.Name]), delay_1(() => (contains(entity, state_1.Selected, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? append(singleton(["className", "is-active"]), delay_1(() => singleton(["onClick", (e) => {
            e.preventDefault();
            dispatch(new UserSelector_SelectMsg(4, [entity]));
        }]))) : singleton(["onClick", (e_1) => {
            e_1.preventDefault();
            dispatch(new UserSelector_SelectMsg(1, [entity]));
        }]))))))))), state_1.Data), createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    })))))));
}

export function UserSelector_UserSelector(userSelector_UserSelectorInputProps) {
    const onSelectedUserChange = userSelector_UserSelectorInputProps.onSelectedUserChange;
    const initialUser = userSelector_UserSelectorInputProps.initialUser;
    const projectId = userSelector_UserSelectorInputProps.projectId;
    let onSelectedUserChange_1;
    const dependencies_1 = [onSelectedUserChange];
    onSelectedUserChange_1 = reactApi.useCallback((users) => {
        onSelectedUserChange(tryHead(users));
    }, dependencies_1);
    const patternInput = reactApi.useState(false);
    const setShowMenu = patternInput[1];
    const ref = reactApi.useRef(undefined);
    const closeMenu = reactApi.useCallback((_arg) => {
        setShowMenu(false);
    }, []);
    const elemRef = ref;
    const callback = closeMenu;
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_2 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_2);
    let removeOptions;
    const dependencies_1_3 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_3);
    let fn;
    const dependencies_1_4 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_4);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_5 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_5);
    let removeOptions_1;
    const dependencies_1_6 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_6);
    let fn_1;
    const dependencies_1_7 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    let patternInput_1;
    const init = UserSelector_init(projectId, choose_1((x) => x, singleton_1(initialUser)));
    patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, (msg, state) => UserSelector_update(onSelectedUserChange_1, msg, state), (_arg_1, _arg_1_1) => {
    }), undefined, [initialUser, onSelectedUserChange_1]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useDebouncer_Static("", (arg_3) => {
        dispatch(new UserSelector_SelectMsg(5, [arg_3]));
    }, 300);
    const query = state_1.Query.toLocaleLowerCase();
    const data = isNullOrWhiteSpace(query) ? state_1.Data : filter((user) => {
        if (user.Name.toLocaleLowerCase().indexOf(query) >= 0) {
            return true;
        }
        else {
            return user.Email.toLocaleLowerCase().indexOf(query) >= 0;
        }
    }, state_1.Data);
    const dropDownContent = isEmpty(state_1.Data) ? singleton_1(createElement("div", createObj(Helpers_combineClasses("dropdown-item", singleton_1(["children", "No results"]))))) : toList(delay_1(() => map_1((entity) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay_1(() => append(singleton(["children", `${entity.Name} <${entity.Email}>`]), delay_1(() => (contains(entity, state_1.Selected, {
        Equals: equals,
        GetHashCode: safeHash,
    }) ? append(singleton(["className", "is-active"]), delay_1(() => singleton(["onClick", (e) => {
        e.preventDefault();
        dispatch(new UserSelector_SelectMsg(4, [entity]));
        closeMenu(e);
    }]))) : singleton(["onClick", (e_1) => {
        e_1.preventDefault();
        dispatch(new UserSelector_SelectMsg(2, [entity]));
        closeMenu(e_1);
    }]))))))))), sortBy((u) => u.Name, data, {
        Compare: comparePrimitives,
    }))));
    return createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay_1(() => append(singleton(["className", join(" ", ["is-full-width", "entity-selector"])]), delay_1(() => append(singleton(["ref", ref]), delay_1(() => append(patternInput[0] ? singleton(["className", "is-active"]) : empty(), delay_1(() => {
        let elems_3, elems_1;
        return singleton((elems_3 = [createElement("div", createObj(ofArray([["className", "tags-input"], (elems_1 = toList(delay_1(() => append(map_1((s) => {
            let elems;
            return createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], (elems = [s.Name, createElement("button", createObj(Helpers_combineClasses("delete", ofArray([["className", "is-small"], ["onClick", (_arg_2) => {
                dispatch(new UserSelector_SelectMsg(4, [s]));
            }]]))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }, state_1.Selected), delay_1(() => singleton(createElement("input", createObj(cons(["type", "search"], Helpers_combineClasses("input", ofArray([["onFocus", (_arg_3) => {
            setShowMenu(true);
        }], ["onChange", (ev_2) => {
            patternInput_2[1](ev_2.target.value);
        }], ["value", patternInput_2[0]], ["placeholder", "Choose User"]])))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton_1(["children", createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(dropDownContent)),
        })]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))]));
    })))))))))));
}

